import Image from "next/image";
import Link from "next/link";
import CallIcon from "../../assets/icons/Call";
import close from "../../assets/icons/cancel-btn.svg";
import styles from "./NavBar.module.css";
import Menu from "./Menu";
import CustomButton from "../../components/Button";
import { useSelector } from "react-redux";
import { processNavBar } from "../../utils/mapping";
import aldar from "@/assets/images/Aldar.webp";

const NavBar = () => {
  const { headerData} = useSelector((state: any) => state.data);
  const processedData = processNavBar(headerData);

// console.log('home logo phase1 --->', processedData?.logoImg );
  return (
    <nav
      className="navbar navbar-expand-lg navbar-light py-4"
      data-testid="navbar-container-id"
    >
      <Link
        href={processedData?.contactusLink || "#"}
        className={styles.contact_link}
      >
        <CustomButton
          icon={<CallIcon />}
          className={`d-flex ${styles.contactBtn}`}
        >
          <span className="d-none d-lg-flex">{processedData?.contactus}</span>
        </CustomButton>
      </Link>
      <button
        className="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarTogglerDemo02"
        aria-controls="navbarTogglerDemo02"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span className="navbar-toggler-icon"></span>
      </button>
      <Link
        className="navbar-brand d-block d-lg-none me-0"
        href={processedData?.logoLink || "#"}
      >
        {/* Mobile logo */}
          <Image
            src={processedData?.logoImg || aldar}
            alt="moblie_logo"
            width={113}
            height={32}
            // sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
            onError={(e:any) => (e.target.src = aldar)}
          />
      </Link>
      <div
        className="collapse navbar-collapse ms-0 ms-lg-5"
        id="navbarTogglerDemo02"
      >
        <button
          className="navbar-toggler close"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarTogglerDemo02"
          aria-controls="navbarTogglerDemo02"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <Image
            src={close}
            alt="call"
            width={24}
            height={24}
            // sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
          />
        </button>
        <Menu menuData={processedData?.menuData} />
      </div>
      <form className="d-none d-lg-block">
        <Link
          className="navbar-brand d-none d-lg-block"
          href={processedData?.logoLink || "#"}
        >

          {/* Webview logo */}
            <Image
              src={processedData?.logoImg || aldar}
              alt="web_logo"
              width={149}
              height={40}
              // sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
              onError={(e:any) => (e.target.src = aldar)}
            />

        </Link>
      </form>
    </nav>
  );
};

export default NavBar;
